<template>
    <div class="row content">
        <div class="col-6">
            <div class="text-center">
                <button
                    class="btn btn-sm btn-sakali m-1"
                    @click="newSpecialBet">
                    Neuer Sondertipp
                </button>
            </div>
            <div class="card-sakali mt-2 px-2"
                 v-if="editedSpecialBet">
                <special-bet-editor
                    :specialBet="editedSpecialBet"
                    @save="save($event)"
                    @cancel="editedSpecialBet = null"/>
            </div>
        </div>
        <div class="col-6">
            <div v-if="!editedSpecialBet"
                 class="text-center">
                Wähle einen Sondertipp, um ihn zu bearbeiten
            </div>
            <special-bet-list
                    class="mt-2"
                    :special-bets="specialBets"
                    @selected="selected"/>
        </div>
    </div>
</template>

<script>

import sakaliApi from '../../sakali-api'

import AdminSpecialBetList from "./AdminSpecialBetList";
import AdminSpecialBetEditor from "./AdminSpecialBetEditor";

export default {
    data() {
        return {
            specialBets: [],
            editedSpecialBet: undefined
        }
    },
    methods: {
        newSpecialBet() {
            this.editedSpecialBet = {
                deadline: new Date().toISOString().slice(0, 16),
                description: '',
                start: new Date().toISOString().slice(0, 16),
                value: 5000,
                finished: false,
                quotaEnabled: true,
                useEmblems: true,
                result: undefined,
                options: [{name: ''}],
                open: true
            }
        },
        selected(specialBet) {
            this.editedSpecialBet = specialBet
        },
        loadSpecialBets() {
            sakaliApi.get('/specialbets').then(response => {
                this.specialBets = response.data;
                this.editedSpecialBet = undefined;
            }).catch(error => {
                this.handleError(error)
            })
        },
        save(specialBet) {
            sakaliApi.post('/specialbets', specialBet).then(() => {
                this.loadSpecialBets();
            }).catch(error => {
                this.handleError(error)
            })
        }
    },
    components: {
        specialBetList: AdminSpecialBetList,
        specialBetEditor: AdminSpecialBetEditor
    },
    mounted() {
        this.loadSpecialBets();
    }
}
</script>
